import { Pipe, PipeTransform } from '@angular/core';
import { CommentPluginService } from './comment-plugin.service';

@Pipe({
    name: 'importancelevel',
    standalone: false
})
export class ImportanceLevelPipe implements PipeTransform {
  public importanceLevels: any;

  constructor(private service: CommentPluginService) {
    this.importanceLevels = this.service.getImportanceLevels();
  }

  transform(id: string): any {
    return this.service.getValue(id, this.importanceLevels);
  }
}
